import type { DaySummary } from '@calorie/shared';
import { ProgressRing } from './ProgressRing.js';

const fmt = (v: number) => Math.round(v).toLocaleString('ru-RU');

/** Раскрывается по нажатию на плашку итога: норма дня и прогресс по БЖУ. */
export function GoalsPanel({ day }: { day: DaySummary }) {
  const { consumed, goals } = day;
  const ratio = goals.kcal > 0 ? consumed.kcal / goals.kcal : 0;
  const over = ratio > 1;

  return (
    <div className="glass goals" role="dialog" aria-label="Норма дня">
      <div className="goals-head">
        <span className="goals-title">Норма дня</span>
        <span className={`goals-kcal${over ? ' over' : ''}`}>
          {fmt(consumed.kcal)} / {fmt(goals.kcal)} ккал
        </span>
      </div>

      <div className="goals-track">
        <div
          className={`goals-fill${over ? ' over' : ''}`}
          style={{ width: `${Math.min(ratio, 1) * 100}%` }}
        />
      </div>

      <div className="goals-rings">
        <ProgressRing value={consumed.protein} goal={goals.proteinG} label="Белки"
                      unit="г" color="var(--macro-p)" />
        <ProgressRing value={consumed.fat} goal={goals.fatG} label="Жиры"
                      unit="г" color="var(--macro-f)" />
        <ProgressRing value={consumed.carbs} goal={goals.carbsG} label="Углеводы"
                      unit="г" color="var(--macro-c)" />
      </div>
    </div>
  );
}
